export default {
  visibleCount: {
    textAlign: 'center',
    fontSize: '12px',
    mt: [24, 24, 48, 80]
  }
};